export default __webpack_public_path__ + "static/media/Marguerite.d857be92.jpg";